<template>

    <PopupModel v-model="isOpen" description="Are you sure delete this record" heading="Delete Result/Certificate"
                @confirm="confirmDelete"/>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
            <p class="text-lg font-medium mb-4">Result & Certificate </p>

            <breeze-table
                :fields="[
                        {'key':'student','label':'Name'},
                        {'key':'type','label':'Type'},
                        {'key':'course','label':'Course/Semester'},
                        {'key':'created_at','label':'Created At'},
                        {'key':'action','label':'action'},
                        ]"
                :items="results"
                :action="{
                        url:route('internal.result-and-certificates.create',[branch_id]),
                        text:'Create',
                    }"
                :searchlink="route('internal.result-and-certificates.index',branch_id)"
                :canCreate="hasRole('Create Result & Certificate')"
                :canView="hasRole('View Result & Certificate')">

                <template #student="{item}">
                    {{ item.first_name }}
                    {{ item.middle_name }}
                    {{ item.last_name }}
                </template>

                <template #type="{item}">
                    <span class="capitalize">{{ item.type }}</span>
                </template>

                <template #course="{item}">
                    <span class="capitalize">{{ item?.course?.title??item?.semester?.title }}</span>
                </template>

                <template #created_at="{item}">
                  {{ tableDate(item.created_at)}}
                </template>

                <template #action="data">

                    <Button @click="handleDeleteResult(data.item);"
                            v-if="hasRole('Edit Result & Certificate')"
                            class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white ml-2 translate-y-1">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             class="w-4 h-4  justify-self-center cursor-pointer"
                             viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </Button>

                </template>

            </breeze-table>

        </div>
    </internal>
</template>
<script setup>
import Internal from '@/Pages/Internal/Internal'
import BreezeTable from '@/Components/Table'
import {ref} from "vue";
import {useForm, usePage} from '@inertiajs/inertia-vue3';
import PopupModel from "@/Components/PopupModel.vue";
import Button from "@/Components/Button.vue";
import {hasRole} from "../../../../Utils/checkPermission";
import {formatDateTypeTwo, tableDate} from "../../../../Utils/Common";

const branch_id = localStorage.branchId;
const isOpen = ref(false);
const results = usePage().props.value.results;

const form = useForm([]);
const id = ref('');

function handleDeleteResult(item) {
    isOpen.value = true;
    id.value = item.id;
}

function confirmDelete() {
    form.post(route('internal.result-and-certificates.destroy', [branch_id, id.value]), {
        onSuccess: () => {
            isOpen.value = false;
            window.location.reload();
        }
    });
}


</script>
